import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  INDEX_WITH_PROFILE_ID_CLUB_EVENTS,
  CLUB_EVENT_SHOW,
  CLUB_EVENT_INDEX_V2
} from "@/utils/api-url";

export default class ClubEvent extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"];
    this.key = params["_id"] || this.Id || "";
    this.clubId = params["clubId"] || this.clubId || {};
    this.clubName =
      (params["clubId"] && params["clubId"]["clubName"]) || this.clubName || "";
    this.eventType =
      (params["eventType"] && params["eventType"]["name"]) ||
      this.eventType ||
      "";
    this.eventName = params["eventName"] || this.eventName || "";
    this.date = this.parseDate(params["date"]);
    this.time = params["time"] || this.time || "";
    this.datetime = `${new Date(
      this.date
    ).toLocaleDateString()}, ${this.time.toUpperCase()}`;
    this.ageGroup =
      (params["age"] && params["age"]["name"]) || this.ageName || "";
    this.location = params["location"] || this.location || "";
  }

  parseDate(date) {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  }

  static resourceName() {
    return "clubEvent";
  }

  static indexWithProfileId(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      INDEX_WITH_PROFILE_ID_CLUB_EVENTS(
        params,
        "events/getALl/clubEvents",
        profileId
      )
    );
  }

  static indexWithProfileIdLimited(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      INDEX_WITH_PROFILE_ID_CLUB_EVENTS(
        { ...params, limit: 3, page: 1 },
        "events/getALl/clubEvents",
        profileId
      )
    );
  }

  static indexV2(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      CLUB_EVENT_INDEX_V2(params.clubId, profileId, {
        ...params,
        collegeId: null,
        profileId: null
      })
    );
  }

  static show(params) {
    return apiDispatcher(CLUB_EVENT_SHOW(params.id, this.profileId()));
  }

  static filterConfig() {
    return [
      {
        component: "BaseTaxonomySelect",
        resource: "clubEventType",
        type: "Club Event Type",
        placeholder: "Event Type",
        allowClear: true,
        column: "eventType",
        searchType: "normal",
        gridComponent: "one",
        filterByLabel: ["Game Schedule"]
      },
      {
        component: "BaseSearchSelectClub",
        placeholder: "Club Name",
        column: "clubId",
        searchType: "normal",
        optionFilterProp: "children",
        showSearch: true,
        filterOption: true,
        allowClear: true,
        gridComponent: "two"
      },
      {
        component: "BaseDatePicker",
        placeholder: "Select Date",
        column: "date",
        searchType: "normal",
        valueFormat: "YYYY/MM/DD",
        gridComponent: "three"
      },
      {
        component: "BaseSortedTaxonomySelect",
        resource: "state",
        type: "State",
        placeholder: "State",
        allowClear: true,
        column: "state",
        searchType: "normal",
        gridComponent: "four",
        optionFilterProp: "children",
        showSearch: true,
        filterOption: true
      },
      {
        component: "BaseInput",
        placeholder: "City",
        column: "q1",
        searchType: "query",
        additionalData: { searchField1: "city" },
        gridComponent: "six"
      },
      {
        component: "BaseInput",
        placeholder: "Address",
        column: "q2",
        searchType: "query",
        additionalData: { searchField2: "location" },
        gridComponent: "seven"
      },
      {
        component: "BaseTaxonomySelect",
        resource: "ageGroup",
        mode: "multiple",
        type: "Age Group",
        placeholder: "Age Group",
        allowClear: true,
        column: "age",
        searchType: "normal",
        gridComponent: "five"
      },
      {
        component: "BaseButton",
        class: "btn btn-default primary-button-extra-class",
        type: "primary",
        searchType: "Submit",
        gridComponent: "eight",
        label: "Search",
        clickable: true
      }
    ];
  }
}
